import { companyTypeService } from '@/services/api/companyType.service';
import i18n from '@/i18n';
import { sharedHelper, alertHelper } from '@/utils';
import { companyTypeModel } from '@/models/api/companyType.model';

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        },
    },
    details: {},
    status: {
        list: true,
        detail: true,
        save: true,
    },
};

export const COMPANY_TYPE_MODULE = "api/companyType";

// ACTIONS
export const GET_ALL_COMPANY_TYPE = 'getAllCompanyType';
export const CREATE_COMPANY_TYPE = 'createCompanyType';
export const GET_COMPANY_TYPE = 'getCompanyType';
export const UPDATE_COMPANY_TYPE = 'updateCompanyType';
export const UPDATE_COMPANY_TYPE_STATUS = 'updateCompanyTypeStatus';

// MUTATIONS
const REQUESTING = "requesting";
const ALL_COMPANY_TYPE_SUCCESS = "allCompanyTypeSuccess";
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";
const GET_COMPANY_TYPE_SUCCESS = "getCompanyTypeSuccess";

export const actions = {
    [GET_ALL_COMPANY_TYPE]({commit}, {filter}) {
        commit(REQUESTING, 'list');
        companyTypeService
            .getAll(filter)
            .then((result) => {
                commit(ALL_COMPANY_TYPE_SUCCESS, {data: result});
                commit(SUCCESS);
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [CREATE_COMPANY_TYPE]({commit, dispatch}, {data, filter}) {
        commit(REQUESTING, 'save');
        return companyTypeService
            .store(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t('label.createX', [i18n.t('message.success')])});
                commit(SUCCESS);
                dispatch(GET_ALL_COMPANY_TYPE, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [GET_COMPANY_TYPE]({commit}, {uuid}) {
        commit(REQUESTING, 'detail');
        return companyTypeService
            .show(uuid)
            .then((result) => {
                commit(SUCCESS);
                commit(GET_COMPANY_TYPE_SUCCESS, result);
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [UPDATE_COMPANY_TYPE]({commit, dispatch}, {data, filter}) {
        commit(REQUESTING, 'save');
        return companyTypeService
            .update(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t('label.updateX', [i18n.t('message.success')])});
                commit(SUCCESS);
                dispatch(GET_ALL_COMPANY_TYPE, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);

            });
    },
    [UPDATE_COMPANY_TYPE_STATUS]({dispatch, commit}, {filter, data}) {
        commit(REQUESTING, 'save');
        return companyTypeService
            .updateStatus(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t(`${data.isActive==0 ? 'message.deleteXSuccess' : 'message.restoreXSuccess'}`, [])});
                commit(SUCCESS);
                dispatch(GET_ALL_COMPANY_TYPE, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
};


export const mutations = {
    [ALL_COMPANY_TYPE_SUCCESS](state, {data}) {
        let companyType = data.data || [];
        state.list.data = companyType;
        state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination);

        if(data.success) {
            state.list.data = companyType.map(item => companyTypeModel(item));
        }
    },
    [GET_COMPANY_TYPE_SUCCESS](state, data) {
        state.details = companyTypeModel(data.data);
    },
    [FAILURE](state) {
        state.status = {
            list: true,
            detail: true,
            save: true,
        };
    },
    [REQUESTING](state, type) {
        state.status[type] = false;
    },
    [SUCCESS](state) {
        state.status = {
            list: true,
            detail: true,
            save: true,
        };
    },
};
